import { useI18n } from "@/coquille-bridge";
import { getKarateUi } from "@/i18n/karateUiI18n.js";
import { demoBadgeLabel, localizeDemoText, officialBadgeLabel, localizeStatusKey } from "@/i18n/localizeDemoText.js";
import { getImportModeLabel, getPhase1PrepStatusLabel, getVisibilityLabel } from "@/i18n/phase1UiHelpers.js";

export function useKarateUi() {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";
  const ui = getKarateUi(locale);
  return {
    locale,
    isEn: locale === "en",
    ui,
    localizeDemo: (text) => localizeDemoText(text, locale),
    demoBadge: demoBadgeLabel(locale),
    officialBadge: officialBadgeLabel(locale),
    statusLabel: (statut) => ui.status[statut] ?? localizeStatusKey(statut, locale) ?? statut,
    visibilityLabel: (key) => getVisibilityLabel(key, locale),
    importModeLabel: (mode) => getImportModeLabel(mode, locale),
    prepStatusLabel: (stats) => getPhase1PrepStatusLabel(stats, locale),
    helpDrawerLabels: ui.helpDrawer,
  };
}
